import React, { FC, useState } from "react";
import SmartListCard from "../SmartListCard";
import { Button } from "../../Buttons";
import injectSheet from "react-jss";
import styleSheet from "./styles";

interface Props {
  disabled?: boolean;
  classes?: any;
  matches?: number;
  errorMessage?: string;
  onCancel?: () => void;
  onSave?: (text: string) => void;
  closeModal?: () => void;
}

const EditList: FC<Props> = props => {
  const [textInput, setTextInput] = useState("");

  const onSave = () => {
    props.onSave ? props.onSave(textInput) : null;
  };

  const onCancel = () => {
    props.onCancel ? props.onCancel() : null;
    props.closeModal ? props.closeModal() : null;
  };

  return (
    <div className={props.classes.container}>
      <SmartListCard
        errorMessage={props.errorMessage}
        onInputUpdate={e => setTextInput(e)}
        type="input"
        textInput={textInput}
        matches={props.matches}
      />
      <div className={props.classes.controls}>
        <Button onClick={() => onCancel()} buttonType={"defaultClear"}>
          Cancel
        </Button>
        <Button
          disabled={textInput.length < 1 || props.disabled}
          onClick={onSave}
          buttonType={"defaultBlue"}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default injectSheet(styleSheet)(EditList);
